import { MaterialCommunityIcons } from '@expo/vector-icons';
import { useCurrentWorkspace } from '@gripp/shared-logic';
import { Colors } from '@gripp/shared-ui';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, Pressable, StyleSheet, Text, View } from 'react-native';
import { AddToGroupsModal } from './addToGroupsModal';

export type AddToGroupsButtonProps = {
  routineIds: string[];
  workspaceId: string;
};

export const AddToGroupsButton = ({ routineIds, workspaceId }: AddToGroupsButtonProps) => {
  const { t } = useTranslation();
  const currentWorkspace = useCurrentWorkspace();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const buttonRef = useRef<View>(null);
  const isWeb = Platform.OS === 'web';

  const count = routineIds?.length ?? 0;

  if (count === 0) {
    return null;
  }

  const getBackgroundColor = () => {
    return isWeb ? Colors.white : Colors.primaryGrayBackground;
  };

  return (
    <View style={styles.container}>
      <View ref={buttonRef}>
        <Pressable
          style={[
            { backgroundColor: getBackgroundColor() },
            styles.button,
          ]}
          onPress={() => setIsModalOpen(true)}
        >
          <MaterialCommunityIcons
            name="plus-box-multiple-outline"
            size={16}
            color={Colors.black}
          />
          <Text style={styles.label}>{t('routines.addToGroups')}</Text>
          <MaterialCommunityIcons
            name="chevron-down"
            size={16}
            color={Colors.black}
          />
        </Pressable>
      </View>

      {isModalOpen && (
        <AddToGroupsModal
          routineIds={routineIds}
          workspaceId={workspaceId}
          anchorRef={buttonRef as any}
          isVisible={isModalOpen}
          onDismiss={() => setIsModalOpen(false)}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    position: 'relative',
    zIndex: 9999,
  },
  button: {
    height: 32,
    borderRadius: 30,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 8,
    marginRight: 8,
  },
  label: {
    fontSize: 16,
    fontWeight: '500',
    letterSpacing: -0.25,
    marginHorizontal: 4,
  },
  badgeStyle: {
    backgroundColor: Colors.primary,
    alignSelf: 'center',
    fontSize: 12,
    fontWeight: '500',
    marginRight: 4,
  },
});
